export default "__VITE_ASSET__knmTGLZG1JipeE4uDCyNVw__"